import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationLogRoute: InvariantJiraRoute = {
	name: 'eoc-integration-log',
	path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
	exact: true,
};
